import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// PWA: Service Worker registrieren mit automatischem Update
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('Service Worker registriert:', registration.scope);

        // Regelmäßig nach Updates suchen (alle 60 Sekunden)
        setInterval(() => {
          registration.update();
        }, 60 * 1000);

        // Check for updates
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              console.log('Neue Service Worker Version verfügbar - aktiviere automatisch');
              // Automatisch aktivieren ohne Nachfrage
              newWorker.postMessage({ type: 'SKIP_WAITING' });
            }
          });
        });

        // Wenn neuer Service Worker die Kontrolle übernimmt, Seite neu laden
        let refreshing = false;
        navigator.serviceWorker.addEventListener('controllerchange', () => {
          if (refreshing) return;
          refreshing = true;
          console.log('Neuer Service Worker aktiv - lade Seite neu');
          window.location.reload();
        });
      })
      .catch((error) => {
        console.error('Service Worker Fehler:', error);
      });
  });
}

// PWA: Install Prompt vorbereiten
let deferredPrompt = null;

window.addEventListener('beforeinstallprompt', (e) => {
  console.log('Install Prompt verfügbar');
  e.preventDefault();
  deferredPrompt = e;
  window.dispatchEvent(new CustomEvent('pwa-install-available'));
});

window.addEventListener('appinstalled', () => {
  console.log('PWA wurde installiert');
  deferredPrompt = null;
  window.dispatchEvent(new CustomEvent('pwa-installed'));
});

// Globale Funktion für Install Prompt
window.showPWAInstallPrompt = () => {
  if (deferredPrompt) {
    deferredPrompt.prompt();
    deferredPrompt.userChoice.then((choiceResult) => {
      if (choiceResult.outcome === 'accepted') {
        console.log('Installation akzeptiert');
      }
      deferredPrompt = null;
    });
    return true;
  }
  return false;
};

// Check if PWA install is available
window.isPWAInstallAvailable = () => {
  return deferredPrompt !== null;
};
